<template>
    <v-container>
    <h1 color="red">You do not have permission to access this page</h1>
    <v-layout row align-center>
        <v-flex md6 class="col text-right">
            <v-btn
                    type="submit"
                    class="btn-large-space btn-danger"
                    v-on:click="$router.go(-1)"
            >Back</v-btn
            >
        </v-flex>
    </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: "UnauthorizedAccess"
    }
</script>

<style scoped>

</style>